module.exports = __webpack_public_path__ + "static/media/Asset.6d010c22.svg";